/**
 * @packageDocumentation
 * @module HackerAPI.User.Hacker.Education
 */
import { __extends } from "tslib";
import Base from "../../../base/base";
/**
 * A data container for things related to a hacker's education
 * @class
 * @extends { HackerAPI.Base }
 */
var Education = /** @class */ (function (_super) {
    __extends(Education, _super);
    /**
     * Creates a new Education instance
     * @constructor
     * @param education
     */
    function Education(_a) {
        var institution = _a.institution, institution_id = _a.institution_id, institutionId = _a.institutionId, current_status = _a.current_status, currentStatus = _a.currentStatus, degree = _a.degree, program = _a.program, minor = _a.minor, graduating_year = _a.graduating_year, graduatingYear = _a.graduatingYear, current_year = _a.current_year, currentYear = _a.currentYear;
        var _this = _super.call(this) || this;
        /**
         * The institution that the user is attending
         * @type { string }
         */
        _this.institution = institution || null;
        /**
         * @type { number }
         */
        _this.institutionId = institution_id || institutionId || null;
        /**
         * @type { HackerAPI.User.Hacker.Education.CurrentStatus }
         */
        _this.currentStatus = current_status || currentStatus || null;
        /**
         * @type { string }
         */
        _this.degree = degree || null;
        /**
         * @type { string }
         */
        _this.program = program || null;
        /**
         * @type { string }
         */
        _this.minor = minor || null;
        /**
         * @type { number }
         */
        _this.graduatingYear = graduating_year || graduatingYear || null;
        /**
         * @type { number }
         */
        _this.currentYear = current_year || currentYear || null;
        return _this;
    }
    return Education;
}(Base));
export default Education;
//# sourceMappingURL=education.js.map